const roles = {
    SystemAdmin: 'SystemAdmin',
    CompanyAdmin: 'CompanyAdmin',
    WebUser: 'WebUser',
    MobileEnforcer: 'MobileEnforcer',
    Clerical: 'Clerical',
    Cashier: 'Cashier',
    Bookkeeper: 'Bookkeeper',
    EnforcerSupervisor: 'EnforcerSupervisor',
    AppealsClerk: 'AppealsClerk',
    HearingOfficer: 'HearingOfficer',
    Viewer: 'Viewer',
    ScofflawSearch: 'ScofflawSearch',
    LpiUser: 'LPIUser',
    ApiUser: 'API',
    TylerCashieringClient: 'TylerCashieringClient',
    ImparkCSR: 'ImparkCSR',
    ImparkCollections: 'ImparkCollections',
    Five9User: 'Five9User'
};

export type ValidRole = typeof roles[keyof typeof roles];

export default roles;
